/**
 * 页脚操作
 */
import React from 'react';
import cls from 'classnames';

import styles from './index.module.scss';

const Index: React.FC<React.PropsWithChildren<{ className?: string }>> = (props) => {
  const { children, className } = props;
  return <div className={cls(styles.footerActions, className)}>{children}</div>;
};

export default Index;
